export const QUESTIONPROMPTS_REQUEST = "QUESTIONPROMPTS_REQUEST";
export const QUESTIONPROMPTS_SUCCESS = "QUESTIONPROMPTS_SUCCESS";
export const QUESTIONPROMPTS_FAILURE = "QUESTIONPROMPTS_FAILURE";

export const QUESTIONPROMPT_CREATE_REQUEST = "QUESTIONPROMPT_CREATE_REQUEST";
export const QUESTIONPROMPT_CREATE_SUCCESS = "QUESTIONPROMPT_CREATE_SUCCESS";
export const QUESTIONPROMPT_CREATE_FAILURE = "QUESTIONPROMPT_CREATE_FAILURE";


export const QUESTIONPROMPT_UPDATE_REQUEST = "QUESTIONPROMPT_UPDATE_REQUEST";
export const QUESTIONPROMPT_UPDATE_SUCCESS = "QUESTIONPROMPT_UPDATE_SUCCESS";
export const QUESTIONPROMPT_UPDATE_FAILURE = "QUESTIONPROMPT_UPDATE_FAILURE";


export const QUESTIONPROMPT_DELETE_REQUEST = "QUESTIONPROMPT_DELETE_REQUEST";
export const QUESTIONPROMPT_DELETE_SUCCESS = "QUESTIONPROMPT_DELETE_SUCCESS";
export const QUESTIONPROMPT_DELETE_FAILURE = "QUESTIONPROMPT_DELETE_FAILURE";